/* Lianne: Filterleiste der Kollektionsseiten (snippets/lianne-filterleiste.liquid).
   Filtern, Sortieren und Entfernen laden nur den Produktbereich nach (Section Rendering API),
   die Adresse wird mitgeführt (Zurück-Taste, teilbarer Link). Der offene Aufklapper bleibt offen,
   damit man mehrere Werte nacheinander anhaken kann. Ohne JS funktioniert das Formular als GET. */
(function () {
  if (window.__lianneFilterleiste) return;
  window.__lianneFilterleiste = true;

  var SEL = '[data-lianne-filterleiste]';
  var laufend = null;
  var timer = null;

  function sektion(el) { return el && el.closest('.shopify-section'); }
  function sektionsId(el) { return el.id.replace('shopify-section-', ''); }

  function adresseAusFormular(form) {
    var p = new URLSearchParams();
    var sort = form.querySelector('select[name=sort_by]');
    new FormData(form).forEach(function (wert, name) {
      if (wert === '') return;
      if (name === 'sort_by' && sort && wert === sort.dataset.default) return;
      p.append(name, wert);
    });
    var q = p.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }

  // „Unisex“ gehört zu „Damen“ und „Herren“: mit einem der beiden mitschicken, ohne beide weglassen.
  // Nur wenn die Kollektion den Wert überhaupt kennt (data-fw-unisex), sonst bleibt die Adresse unverändert.
  var FW = 'filter.p.m.custom.fuer_wen';
  function unisexMitnehmen(adresse, form) {
    if (!form || !form.querySelector('[data-fw-unisex]')) return adresse;
    var u = new URL(adresse, window.location.origin);
    var w = u.searchParams.getAll(FW);
    var erw = w.some(function (x) { return x === 'Damen' || x === 'Herren'; });
    var hat = w.indexOf('Unisex') >= 0;
    if (erw === hat) return adresse;
    u.searchParams.delete(FW);
    w.forEach(function (x) { if (x !== 'Unisex') u.searchParams.append(FW, x); });
    if (erw) u.searchParams.append(FW, 'Unisex');
    return u.pathname + u.search;
  }

  function laden(adresse, inVerlauf) {
    var form = document.querySelector(SEL);
    adresse = unisexMitnehmen(adresse, form);
    var grid = sektion(form);
    if (!grid) { window.location.href = adresse; return; }
    var nav = document.querySelector('.lunav');
    var kopf = sektion(nav);
    var ids = [sektionsId(grid)];
    if (kopf) ids.push(sektionsId(kopf));

    var offen = form.querySelector('.lfl__dd[open]');
    var offenKey = offen ? offen.dataset.key : null;
    var panelScroll = offen ? offen.querySelector('.lfl__panel').scrollTop : 0;

    if (laufend) laufend.abort();
    laufend = new AbortController();
    grid.classList.add('lfl-laedt');

    var url = new URL(adresse, window.location.origin);
    url.searchParams.set('sections', ids.join(','));

    // kein Accept-Header: mit „application/json“ liefert Shopify die Kollektion als JSON statt der Abschnitte
    fetch(url.toString(), { signal: laufend.signal })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (teile) {
        var neuGrid = new DOMParser().parseFromString(teile[ids[0]], 'text/html').getElementById(grid.id);
        if (!neuGrid) throw new Error('Abschnitt fehlt');
        grid.innerHTML = neuGrid.innerHTML;
        if (kopf && teile[ids[1]]) {
          var neuNav = new DOMParser().parseFromString(teile[ids[1]], 'text/html').querySelector('.lunav');
          if (neuNav) document.querySelector('.lunav').replaceWith(neuNav);
        }
        // Am Handy liegt der Aufklapper fest über der Seite – nach der Auswahl schließen, damit man die Produkte sieht
        if (offenKey && !window.matchMedia('(max-width: 749px)').matches) {
          var wieder = grid.querySelector('.lfl__dd[data-key="' + CSS.escape(offenKey) + '"]');
          if (wieder) { wieder.open = true; wieder.querySelector('.lfl__panel').scrollTop = panelScroll; }
        }
        if (inVerlauf) history.pushState({ lianneFilter: true }, '', adresse);
        document.dispatchEvent(new CustomEvent('collection:reloaded'));
      })
      .catch(function (e) {
        if (e.name === 'AbortError') return;
        console.warn('Lianne-Filterleiste: Nachladen fehlgeschlagen, lade Seite neu', e);
        window.location.href = adresse; // Rückfall: normal laden
      })
      .finally(function () { grid.classList.remove('lfl-laedt'); });
  }

  // für den Strickset-Finder (assets/lianne-finder.js)
  window.lianneFilterLaden = function (adresse) { laden(adresse, true); };

  document.addEventListener('change', function (e) {
    var form = e.target.closest(SEL);
    if (!form || e.target.type === 'number') return; // Preis erst mit „Anwenden“ oder Enter
    clearTimeout(timer);
    timer = setTimeout(function () { laden(adresseAusFormular(form), true); }, 250);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest(SEL);
    if (!form) return;
    e.preventDefault();
    var offen = form.querySelector('.lfl__dd[open]');
    if (offen) offen.open = false;
    laden(adresseAusFormular(form), true);
  });

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.lfl__chip');
    if (chip) { e.preventDefault(); laden(chip.href, true); return; }
    if (!e.target.closest('.lfl__dd')) {
      document.querySelectorAll(SEL + ' .lfl__dd[open]').forEach(function (d) { d.open = false; });
    }
  });

  // nur ein Aufklapper offen (toggle blubbert nicht → Capture-Phase)
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('lfl__dd') || !d.open) return;
    document.querySelectorAll(SEL + ' .lfl__dd[open]').forEach(function (x) { if (x !== d) x.open = false; });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(SEL + ' .lfl__dd[open]').forEach(function (d) { d.open = false; });
  });

  // Wer scrollt, will die Produkte sehen: offenen Aufklapper schließen (Rückmeldung 07.10.2026)
  var scrollStart = null;
  window.addEventListener('scroll', function () {
    var offen = document.querySelector(SEL + ' .lfl__dd[open]');
    if (!offen) { scrollStart = null; return; }
    if (scrollStart === null) { scrollStart = window.scrollY; return; }
    if (Math.abs(window.scrollY - scrollStart) > 60) { offen.open = false; scrollStart = null; }
  }, { passive: true });

  window.addEventListener('popstate', function () {
    if (document.querySelector(SEL)) laden(window.location.href, false);
  });
})();
